import styled from 'styled-components'
import { device } from '../Breakpoints'

const Container = styled.div`
  background: #f9faf7;
  width: 100%;
  @media ${device.desktop} {
    min-height: 434px;
  }
  @media ${device.laptop} {
    min-height: 292px;
  }
  @media ${device.tablet} {
    min-height: 220px;
  }
  @media ${device.mobileL} {
    padding-bottom: 60px;
    min-height: 384px;
  }
  .slick-slide img {
    width: 100%;
  }
  .slick-prev {
    left: 30px !important;
    z-index: 9999;
    width: 50px;
  }
  .arrow {
    bottom: 17px !important;
    position: absolute;
    background: #f0f0f0;
    display: block;
    border-radius: 100%;
    z-index: 4;
    color: #7b7b7b;
    text-align: center;
    cursor: pointer;
    :hover {
      background: #c3c3c3;
    }
    @media ${device.mobileL} {
      bottom: -46px !important;
    }
  }
  .prev {
    left: 39% !important;
    width: 26px;
    height: 33px;
    padding: 3px 8px 0px 3px;
    @media ${device.mobileL} {
      left: 10% !important;
    }
  }
  .next {
    right: 39% !important;
    width: 26px;
    height: 33px;
    padding: 3px 6px 0px 5px;
    @media ${device.mobileL} {
      right: 10% !important;
    }
  }
  .slick-dots {
    bottom: 25px !important;
    @media ${device.mobileL} {
      bottom: -40px !important;
    }
  }
`
export default Container
